import { FC } from 'react';
import { EmptyView, IllustEmptyError, IllustEmptyNetworkError } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

interface Props {
  isNetworkError?: boolean;
  title?: string;
  description?: string;
  retry?: () => void;
  icon?: React.ReactElement;
  size?: 'medium' | 'small';
}

const defaultTitle = '서비스 이용이 원활하지 않아요';
const defaultDescription = '불편을 드려 죄송해요.\n잠시 후에 다시 시도해주세요.';

export const EmptyViewError: FC<React.PropsWithChildren<Props>> = ({
  isNetworkError = false,
  title,
  description,
  retry,
  icon,
  size = 'medium',
}: Props) => {
  return (
    <Container>
      <EmptyView
        size={size}
        icon={icon ?? (isNetworkError ? <IllustEmptyNetworkError /> : <IllustEmptyError />)}
        title={title || defaultTitle}
        description={description || defaultDescription}
        action={retry ? { text: '다시 시도', onClick: retry } : undefined}
      />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${vars.color.backgroundSurface};
`;
